<template>
    <v-container v-resize="onResize">
        <statistical-header :title="title"></statistical-header>
        <loader v-if="loading" />
        <template v-if="!loading">
            <statistical-member-or-senator-selector :value="selectedMpOrSenator" @input="selectedMpOrSenator = $event" />
            <br/>

            <chart :chartData="chartData"/>  

            <br/>

            <v-data-table
                :headers="headers" 
                :items="items"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :hide-headers="isMobile"
                :class="{ mobileDataTable: isMobile, 'elevation-1': true }"
                :loading="loading">
                <template v-slot:items="props">
                    <template v-if="isMobile">
                        <tr>
                            <td>
                                <div class="flex-content">
                                    <div class="flex-item">
                                        <h3><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}">{{ props.item.Person }}</router-link></h3>
                                    </div>
                                    <div class="flex-item flex-item-col flex-item-col-30">
                                        <div class="flex-item">
                                            <Portrait v-bind:PHID="props.item.Phid" :fixedWidth="80"></Portrait>
                                        </div>
                                    </div>
                                    <div class="flex-item flex-item-col flex-item-col-70">
                                        <div class="flex-item" data-label="Date of commencement of service">
                                            {{ props.item.CommencementOfService | stringDateFormat }}
                                        </div>
                                        <div class="flex-item" data-label="Party">
                                            <a @click="handlePartyClick(props.item.Party)">{{ props.item.Party }}</a>
                                        </div>
                                        <div class="flex-item" data-label="State">
                                            <a @click="handleStateClick(props.item.StateId)">{{ props.item.State }}</a>
                                        </div>
                                        <div class="flex-item" data-label="Years of service">
                                            {{ props.item.YearsOfService }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </template>
                    <template v-if="!isMobile">
                        <td class="text-xs-left">
                            <Portrait v-bind:fixedWidth="80" v-bind:PHID="props.item.Phid"></Portrait>
                        </td>
                        <td class="text-xs-left"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Phid }}">{{ props.item.Person }}</router-link></td>
                        <td class="text-xs-left">{{ props.item.CommencementOfService | stringDateFormat }}</td>
                        <td class="text-xs-left"><a @click="handleStateClick(props.item.StateId)">{{ props.item.State }}</a></td>
                        <td class="text-xs-left"><a @click="handlePartyClick(props.item.Party)">{{ props.item.Party }}</a></td>
                        <td class="text-xs-left"> {{ props.item.YearsOfService }}</td>
                    </template>
                </template>
            </v-data-table>
            <br/>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                        <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                        <span>&nbsp;Download as CSV</span>
                    </v-btn>
                </v-flex>
            </v-layout>            
        </template>
    </v-container>
</template>
<script>
import Loader from '@/components/Loader.vue';
import StatisticalHeader from './StatisticalHeader.vue';
import StatisticalMemberOrSenatorSelector from './StatisticalMemberOrSenatorSelector.vue';
import Chart from './Chart.vue';
import axios from 'axios';
window.Handbook = window.Handbook || {}
const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
axios.defaults.baseURL = apiUri;
import orderBy from 'lodash.orderby';
import Portrait from '@/components/Portrait.vue'
import groupBy from 'lodash.groupby';
import map from 'lodash.map';

export default {
    created() {
        this.initialiseItems();
    },
    components: {
        Loader,
        StatisticalHeader,
        StatisticalMemberOrSenatorSelector,
        Chart,
        Portrait,
    },
    methods: {
        initialiseItems() {
            this.loading = true;
            const parliamentarianType = this.selectedMpOrSenator.length == 0 || this.selectedMpOrSenator.length == 2 ?
                '' : this.selectedMpOrSenator[0];
            const url = `StatisticalInformation/PeriodOfService?parliamentariantype=${parliamentarianType}`;
            axios.get(`api/${url}`)
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                });
        },
        filterMpOrSenator() {
            this.initialiseItems();
        },
        handlePartyClick(partyId) {
            const query = {
                "logicalOperator":"all",
                "children":[
                    {"type":"query-builder-rule", "query":{"rule":"inCurrentParliament","selectedOperand":"In current Parliament","value":"Yes"}}
                ]};
            if (partyId) {
                var partyVal = "[{\"field\":\"RefList1\",\"value\":[],\"simpleValue\":[],\"textValue\":\"" + partyId + "\",\"dateValue\":null,\"fieldType\":null}]";
                query.children.push({"type":"query-builder-rule","query":{"rule":"parties.represented.new","selectedOperator":"of","selectedOperand":"Parties represented", "value":partyVal }});
            }
            this.handleParliamentarianType(query);
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        handleStateClick(stateId) {
            const query = {
                "logicalOperator":"all",
                "children":[
                    {"type":"query-builder-rule", "query":{"rule":"inCurrentParliament","selectedOperand":"In current Parliament","value":"Yes"}}
                ]};
            if (stateId) {
                query.children.push({"type":"query-builder-rule","query":{"rule":"state","selectedOperator":"of","selectedOperand":"State","value":stateId}});
            }
            this.handleParliamentarianType(query);
            localStorage.query = JSON.stringify(query);    
            this.$router.push('/AdvancedSearch');
        },
        handleParliamentarianType(query) {
            if (this.selectedMpOrSenator.length == 1) {
                const selected = this.selectedMpOrSenator[0];
                switch (selected) {
                    case 'senator':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"senator"}});
                        break;
                    case 'mp':
                        query.children.push({"type":"query-builder-rule","query":{"rule":"mpOrSenator","selectedOperand":"Member or Senator","value":"member"}});
                }
            }
        },
        exportCsv: function () {
            this.csvDownloading = true;
            const records = this.items.map(i => ({ 
                Phid: i.Phid,
                'Date of commencement of service': this.formatDate(i.CommencementOfService, '', 'YYYY-MM-DD', false), 
                Parliamentarian: i.Person, 
                'State or Territory': i.State,
                Party: i.Party,
                'Years of service': i.YearsOfService,
                'Days of service': i.DaysOfService
                }));
            let headers = this.headers.map(h => h.text);
            const filename = 'Period of service';
            const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
            this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                .catch(this.showError)
                .finally(() => this.csvDownloading = false);
        } ,
        onResize() {
            if (window.innerWidth < 769){
                this.isMobile = true;
            }
            else{
                this.isMobile = false;
            }
        },       
    },
    computed: {
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            chartData() {
                // group items by party
                const grouped = groupBy(this.items, d => d.Party);
                const series = orderBy(map(
                grouped,
                (value, key) => ({
                    name: key,
                    color: value[0].PartyColour,
                    data: value.map(v => ({
                        name: v.Person,                    
                        phid: v.Phid,
                        party: key,
                        value: v.YearsOfService
                    }))
                })), [s => s.name], ['asc']);
                
                return {
                    chart: {
                        type: 'packedbubble',
                        height: 600,
                    },
                    title: {
                        text: 'Length of service by party'
                    },
                    tooltip: {
                        formatter: function () {
                            return this.point.name ? `<strong>${this.point.name}:</strong> (${this.point.party}) ${this.point.value} years of service` : this.series.name
                        },
                        backgroundColor: 'rgba(255, 255, 255, 0)',
                        shadow: false,
                        borderWidth: 0,
                        borderRadius: 0,
                        useHTML: true,
                    },
                    exporting: {
                        enabled: false
                    },
                    plotOptions: {
                        //  series: {
                        //     animation: false
                        // },
                        packedbubble: {
                            minSize: '25%',
                            maxSize: '150%',
                            layoutAlgorithm: {
                                // enableSimulation: false,
                                gravitationalConstant: 0.02,
                                splitSeries: true,
                                seriesInteraction: false,
                                dragBetweenSeries: false,
                                parentNodeLimit: true,
                                // initialPositionRadius: 12,
                                bubblePadding: 12,
                                parentNodeOptions: {
                                    // initialPositionRadius: 20,
                                    // bubblePadding: 30
                                }
                            },
                            dataLabels: {
                                enabled: true,
                                useHTML: true,
                                crop: false,
                                filter: {
                                    property: 'y',
                                    operator: '>',
                                    value: 5
                                },
                                // format: '<a class="parliamentarian__label" href="/Parliamentarian/{point.phid}"><img src="https://www.aph.gov.au/api/parliamentarian/{point.phid}/image" style="width: 20px;border-radius: 10px;"></img></a>',
                                formatter: function () {
                                    const height = this.point.marker.height;
                                    const borderRadius = height / 2;
                                    return `<a class="parliamentarian__label" href="/Parliamentarian/${this.point.phid}"><img src="https://www.aph.gov.au/api/parliamentarian/${this.point.phid}/image" height="${height}" style="height: ${height}px;border-radius: ${borderRadius}px;"></img></a>`
                                }
                            }
                        },
                    },
                    series
                }
            }           
    },    
    mounted(){
        this.onResize();
    },
    watch: {
        selectedMpOrSenator: function () {
            this.initialiseItems();
        }
    },
    data() {
        return {
        title: 'Periods of service—current Parliament',
        isMobile: false,
        pagination: {
            descending: true,
            sortBy: 'YearsOfService'
        },
        headers: [
            {
                text: '',
                value: 'Person',
                sortable: false
            },
         
            {
                text: 'Parliamentarian',
                value: 'Person' 
            },
            {
                text: 'Date of commencement of service',
                value: 'CommencementOfService'
            },
            {
                text: 'State or Territory',
                value: 'State'
            },
            {
                text: 'Party',
                value: 'Party'
            },
            {
                text: 'Years of service',
                value: 'YearsOfService'
            }
        ],
        items: [],
        search: '',
        loading: true,
        csvDownloading: false,
        selectedMpOrSenator: ['senator', 'mp'],
        memberOrSenator: 'member',
        rowsPerPageItems: [ 10, 25, {
            "text": "$vuetify.dataIterator.rowsPerPageAll",
            "value": -1
            }]
        }
    }
}
</script>
<style scoped>
    a {
        text-decoration: none;
    }
</style>
<style>
    .highcharts-parentNode.highcharts-packedbubble-series {
        opacity: 0;
    }
</style>